var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssVars),attrs:{"id":"app"}},[_c('div',{staticClass:"nav"},[_c('router-link',{attrs:{"to":"/home"}},[_c('img',{staticClass:"nav-image",attrs:{"alt":"PDOK logo","src":_vm.logo}})])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }